import * as Utils from './utils.js';

export default el => { 
    const btns = el.querySelectorAll('.js-single-infrastructure-residence-btn');
    const data = Utils.getTrackingData();
    data.event = 'click';

    btns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (!window.dataLayer) window.dataLayer = [];
            window.dataLayer.push(data);
            window.open(btn.href, '_blank')
        })
    })
};
